import Layer from "ol/layer/Layer";
import Source from "ol/source/Source";
import { compose as composeTransform, create as createTransform, toString as formatTransform, rotate as rotateTransform, scale as scaleTransform, translate as translateTransform } from "ol/transform";

export class ATOMSLayer extends Layer {
	// _map;
	// _elements;
	// _viewState; _renderedViewState;
	// _worker; _workerReady; _workerFailed;
	// _readyWorker$; _settleReadyWorker;
	// _lastFrameState;

	constructor(map, options = {}) {
		super(options);
		this.setSource(new Source({}));
		this._map = map;
		window._atomsLayer = this;
	}

	setVisible(visible) {
		super.setVisible(visible);
		if (!visible) this._terminateWorker();
	}

	setLayersVisible(layerIds) {
		this._getReadyWorker$().then(worker => {
			worker.postMessage({
				action: 'set-layers-visible', layerIds
			});
		}).catch(() => {});
	}

	render(frameState) {
		this._viewState = frameState.viewState;
		this._lastFrameState = frameState;
		this._updateTransform();
		this._renderFrame(frameState);
		return this._obtainElements().root;
	}

	_updateTransform() {
		if (!this._renderedViewState) return;
		const transform = createTransform();
		const resolution = this._viewState.resolution;
		const dX = (this._renderedViewState.center[0] - this._viewState.center[0]) / resolution;
		const dY = -(this._renderedViewState.center[1] - this._viewState.center[1]) / resolution;
		const dResolution = this._renderedViewState.resolution / resolution;
		const dRotation = -(this._renderedViewState.rotation - this._viewState.rotation);
		if (this._viewState.rotation == 0) composeTransform(transform, dX, dY, dResolution, dResolution, dRotation, 0, 0);
		else {
			const sin = Math.sin(this._viewState.rotation), cos = Math.cos(this._viewState.rotation);
			translateTransform(transform, dX * cos - dY * sin, dX * sin + dY * cos);
			if (dResolution != 1) scaleTransform(transform, dResolution, dResolution);
		}
		if (dRotation != 0) rotateTransform(transform, dRotation);
		this._obtainElements().transformer.style.transform = formatTransform(transform);
	}

	_renderFrame(frameState) {
		if (this.pendingRender) {
			frameState.animate = true;
			return;
		}
		const worker = this._obtainWorker();
		if (!worker) return;
		worker.postMessage({
			action: 'render'
			, frameState: {
				viewHints: frameState.viewHints.slice(0)
				, viewState: {
					center: frameState.viewState.center.slice(0)
					, resolution: frameState.viewState.resolution
					, rotation: frameState.viewState.rotation
					, zoom: frameState.viewState.zoom,
				}
				, pixelRatio: frameState.pixelRatio
				, size: frameState.size.slice(0), extent: frameState.extent.slice(0)
				, coordinateToPixelTransform: frameState.coordinateToPixelTransform.slice(0)
				, pixelToCoordinateTransform: frameState.pixelToCoordinateTransform.slice(0)
			}
		});
		this.pendingRender = true;
	}

	_updateFrame(message) {
		const bitmap = message.bitmap;
		if (!bitmap) return;
		requestAnimationFrame(() => {
			const canvas = this._obtainElements().canvas;
			canvas.width = bitmap.width;
			canvas.height = bitmap.height;
			canvas.getContext('2d').drawImage(bitmap, 0, 0);
			canvas.style.transform = message.transform;
			this._renderedViewState = message.viewState;
			this._updateTransform();
		});
	}

	_obtainWorker() {
		if (!this._worker) {
			if (this._workerFailed) return null;
			this._worker = this._createWorker();
		}
		if (!this._workerReady) return null;
		return this._worker;
	}

	_getReadyWorker$() {
		if (!this._readyWorker$) this._readyWorker$ = new Promise((resolve, reject) => {
			const worker = this._obtainWorker();
			if (worker) resolve(worker);
			else if (this._workerFailed) reject(this._workerFailed);
			else this._settleReadyWorker = () => {
				if (this._worker && this._workerReady) resolve(this._worker);
				else reject(this._workerFailed || new Error('ATOMS worker is not available'));
			};
		});
		return this._readyWorker$;
	}

	_createWorker() {
		this._log('Starting ATOMS worker');
		const worker = new Worker(new URL('/lib/atoms-worker.js', window.location.origin));
		worker.addEventListener('message', ({data: message}) => {
			switch (message.action) {
				case 'render-complete':
					this._updateFrame(message);
					this.pendingRender = false;
					return;
				case 're-render':
					this._map.render();
					if (this._lastFrameState) {
						this._renderFrame(this._lastFrameState);
					}
					return;
				case 'ready':
					this._log('ATOMS worker ready');
					this._workerReady = true;
					if (this._settleReadyWorker) this._settleReadyWorker();
					this._map.render();
					return;
				case 'loadImage':
					this._loadImade$(message.src).then(bitmap => {
						worker.postMessage({
							action: 'imageLoaded'
							, src: message.src
							, image: bitmap
						}, [bitmap]);
					});
					return;
				case 'error':
					this._abortWorker(message.error);
					return;
			}
			this._log('Unknown worker message', message);
		});
		worker.addEventListener('error', event => this._abortWorker(event));
		return worker;
	}

	_loadImade$(src) {
		return new Promise((resolve, reject) => {
			const image = new Image();
			image.crossOrigin = 'anonymous';
			image.addEventListener('load', () => resolve(createImageBitmap(image, 0, 0, image.width, image.height)));
			image.addEventListener('error', () => reject(new Error('Failed to load image')));
			image.src = src;
		});
	}

	_abortWorker(error) {
		this._log('Aborting ATOMS worker', error);
		this._terminateWorker();
		this._workerFailed = error || new Error('ATOMS worker failed');
	}

	_terminateWorker() {
		if (!this._worker) return;
		this._log('Terminating ATOMS worker');
		this._worker.terminate();
		this._worker = null;
		this._workerReady = false;
		this._readyWorker$ = null;
		this._settleReadyWorker = null;
	}

	_obtainElements() {
		if (this._elements) return this._elements;
		return this._elements = this._createElements();
	}

	_createElements() {
		const element = (tag, style) => {
			const element = document.createElement(tag);
			for (const property in style) element.style[property] = style[property];
			return element;
		};
		const root = element('div', {
			position: 'absolute', width: '100%', height: '100%'
		});
		const transformer = root.appendChild(element('div', {
			position: 'absolute', width: '100%', height: '100%'
		}));
		const canvas = transformer.appendChild(element('canvas', {
			position: 'absolute', left: '0', transformOrigin: 'top left'
		}));
		return {root, transformer, canvas};
	}

	disposeInternal() {
		this._log('ATOMS layer disposing');
		this._terminateWorker()
		super.disposeInternal();
	}

	_log(...args) {
		console.log(...args);
	}
}
